// extracted by mini-css-extract-plugin
module.exports = {"listWrap":"lift-report_listWrap_33WdN","scoreIcon":"lift-report_scoreIcon_1z07P"};